<template>
  <div :class="style.actionsVertical" v-if="!isSetting">
    <span
      v-if="modifyQuiz('get', '', ['actionHeader'])"
      v-text="modifyQuiz('get', '', ['actionHeader'])"
    />

    <div :class="style.actionList">
      <div :class="style.action" v-for="(action, key) of actionList" :key="key">
        <div v-if="action.header !== ''" :class="style.wrapperAction">
          <p
            :class="style.numeric"
            v-text="key + 1"
            v-if="!quiz?.styleContacts?.isDot"
          />

          <p
            :class="[style.numeric, style.dot]"
            v-text=""
            v-if="quiz?.styleContacts?.isDot"
          />

          <p
            :class="style.content"
            v-text="action.header"
            :style="{
              borderBottom:
                Number(key) === actionList.length - 1
                  ? 'none'
                  : '1px dashed #F1F1F1'
            }"
          />
        </div>
      </div>
    </div>
  </div>

  <div :class="[style.actionsVertical, style.editable]" v-else>
    <textarea
      :value="actionHeader"
      @input="setHeaderActionList($event)"
      :class="style.headerTextArea"
      placeholder="Заголовок акций"
    ></textarea>

    <div :class="[style.actionList, style.editable]">
      <div :class="style.action" v-for="(action, key) of actionList" :key="key">
        <div :class="[style.wrapperAction, style.editable]">
          <p
            :class="style.numeric"
            v-text="key + 1"
            v-if="!quiz?.styleContacts?.isDot"
          />

          <p
            :class="[style.numeric, style.dot]"
            v-text=""
            v-if="quiz?.styleContacts?.isDot"
          />

          <AutoResizeTextArea
            :class="style.content"
            :value="modifyQuiz('get', '', ['actionList', key, 'header'])"
            @input="setHeaderAction($event, key)"
            :style="{paddingBottom: 0, paddingLeft: '5px'}"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import style from "./ActionVerticalComponent.module.scss";
import {modifyQuiz} from "@/page/quiz/scriptQuiz";
import {defineComponent} from "vue";
import AutoResizeTextArea from "@/elements/autoResizeTextArea/autoResizeTextArea.vue";
import {Quiz} from "@/page/quiz/typeQuiz";

type ActionItem = {
  header: string;
  [key: string]: unknown;
};

export default defineComponent({
  name: "ActionVerticalComponent",

  components: {
    AutoResizeTextArea
  },

  props: {
    isSetting: Boolean
  },

  data() {
    return {
      style,
      modifyQuiz
    };
  },

  mounted() {
    this.normalizeActionHeader();
    this.normalizeActionList();
  },

  methods: {
    getVisibleActionList(actions: ActionItem[]): ActionItem[] {
      if (this.isSetting) {
        return actions;
      }

      const seen = new Set<string>();

      return actions.filter((action) => {
        const signature = JSON.stringify(action);

        if (seen.has(signature)) {
          return false;
        }

        seen.add(signature);
        return true;
      });
    },
    setHeaderActionList(event: Event) {
      const target = event.target as HTMLTextAreaElement;
      this.modifyQuiz("set", target.value, ["actionHeader"]);
    },

    setHeaderAction(event: Event, key: number) {
      const target = event.target as HTMLTextAreaElement;
      this.modifyQuiz("set", target.value, ["actionList", key, "header"]);
    },

    normalizeActionHeader() {
      const currentActionHeader = this.modifyQuiz("get", "", ["actionHeader"]);

      if (!currentActionHeader && this.quiz?.actionHeader) {
        this.modifyQuiz("set", this.quiz.actionHeader, ["actionHeader"]);
      }
    },

    normalizeActionList() {
      const currentActionList = this.modifyQuiz("get", "", ["actionList"]);

      if (Array.isArray(currentActionList)) {
        return;
      }

      if (currentActionList && typeof currentActionList === "object") {
        this.modifyQuiz("set", Object.values(currentActionList), [
          "actionList"
        ]);
        return;
      }

      this.modifyQuiz("set", [], ["actionList"]);
    }
  },

  computed: {
    quiz(): Quiz | null {
      return this.$quizStore.getQuiz || null;
    },

    getVersionLK() {
      return this.$quizStore.getSelectedVersion;
    },

    actionList(): ActionItem[] {
      const currentActionList = this.modifyQuiz("get", "", ["actionList"]);

      if (Array.isArray(currentActionList)) {
        return this.getVisibleActionList(currentActionList);
      }

      if (currentActionList && typeof currentActionList === "object") {
        return this.getVisibleActionList(
          Object.values(currentActionList) as ActionItem[]
        );
      }

      return [];
    },

    actionHeader(): string {
      const currentActionHeader = this.modifyQuiz("get", "", ["actionHeader"]);

      if (!currentActionHeader && this.quiz?.actionHeader) {
        this.modifyQuiz("set", this.quiz.actionHeader, ["actionHeader"]);
        return this.quiz.actionHeader;
      }

      return currentActionHeader || "";
    }
  },

  watch: {
    quiz: {
      handler() {
        this.normalizeActionHeader();
        this.normalizeActionList();
      },
      deep: true,
      immediate: true
    }
  }
});
</script>
